







import ListCard from '@/components/list-cards/ListCard.vue';
import ListCardSmallWide from '@/components/list-cards/ListCardSmallWide.vue';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { UserProfileUtil } from '@/model-utils/user-profile-util';
import { UserProfile } from '../models/user-profile';
import { UserModule, UserStore } from '../store/modules/user';

import { auth } from '@/firebase';
import UserProfileCard from '../components/UserCard.vue';

@Component({
  components: { ListCard, ListCardSmallWide }
})
export default class AllLists extends Vue {
  @Prop(String) public readonly username!: string;
  @Prop(Object) public readonly userProfile?: UserProfile;
  loadedProfile: UserProfile = this.userProfile;

  public lists: ListModel[] = [];

  public created() {
    this.tryLoadLists();

    if (!this.userProfile) {
      UserProfileUtil.fetchProfileByUsername(this.username).then((profile) => {
        
        this.loadedProfile = profile;
        this.$forceUpdate();
      });
    }
  }

  tryLoadLists() {
    if (auth.currentUser != null && UserModule.userProfile == null) {
      return;
    }

    let currentUsername: string = null;
    if (UserModule.userProfile.username) {
      currentUsername = UserModule.userProfile.username;
    }
    ListModelUtil.getAllListsByUsername({
      username: this.username,
      currentUsername: currentUsername,
      limit: 100
    }).then(lists => {
      this.lists = lists;
    });
  }
}
